const ENTITIES: Record<string, string> = {
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">",
  "&quot;": '"',
  "&#39;": "'",
  "&apos;": "'",
  "&#x27;": "'",
  "&#x2F;": "/",
};

/**
 * Decode the common HTML entities for display. Runs twice so double-escaped
 * values (e.g. "&amp;amp;" → "&amp;" → "&") collapse fully. Idempotent and a
 * no-op on strings without "&".
 */
export function decodeEntities(input: string): string {
  if (!input || input.indexOf("&") === -1) return input;
  let out = input;
  for (let i = 0; i < 2; i++) {
    out = out.replace(/&(?:amp|lt|gt|quot|apos|#39|#x27|#x2F);/g, (m) => ENTITIES[m] ?? m);
  }
  return out;
}
